#import '../../../../../core-entity/graphql/fragments/core-entity-task-fragment.graphql'

mutation CreateTask($input: TaskCreateInput!) {
    taskCreate(input: $input) {
        task {
            ...CoreEntityTaskFragment
        }
    }
}
